import constants from "../constants";

export default function (token, options) {

  let params = [`token=${encodeURIComponent(token)}`];

  if (options) for (let key in options)
    params.push(`${key}=${encodeURIComponent(options[key])}`);

  return token && token.length ? `${constants.BASE_SERVICE_URL}vbAttachmentToken/secure/downloadFileImage?${params.join("&")}` : null;
}



// WEBPACK FOOTER //
// ./src/filters/buildAttachmentImage.js